function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function isObj(obj) {
  return obj !== null && typeof obj === 'object' && !Array.isArray(obj);
}

function depthFirstObjectMerge() {
  for (var _len = arguments.length, obj = new Array(_len), _key = 0; _key < _len; _key++) {
    obj[_key] = arguments[_key];
  }

  if (obj.length === 1) {
    return obj[0];
  }

  return obj.reduceRight(function (current, target) {
    var currentKeys = Object.keys(current);
    var previousKeys = Object.keys(target);

    var res = _extends({}, target);

    for (var keyIndex = 0; keyIndex < currentKeys.length; keyIndex++) {
      var currentKey = currentKeys[keyIndex];
      var value = current[currentKey]; // if current value is not in previous value, use it as it is

      if (!previousKeys.includes(currentKey)) {
        res[currentKey] = value;
      } else if (isObj(value)) {
        // current value is an object, perform deep merge if the both values are objects
        if (isObj(target[currentKey])) {
          res[currentKey] = depthFirstObjectMerge(target[currentKey], value);
        } else {
          res[currentKey] = value;
        }
      } else {
        res[currentKey] = value;
      }
    }

    return res;
  });
}

function toArray(value, expectedLength) {
  var normalized = Array(expectedLength);

  if (Array.isArray(value)) {
    normalized.unshift.apply(normalized, value);
  } else {
    normalized.fill(value);
  }

  return normalized;
}

function getResponsiveValue(breakpoint, defaultValue, newValue) {
  // null in default means, there is no value
  // null in value means, there is no value, even if there is a value in default
  // undefined in default means, there is no value
  // undefined in value means, use the default value at given index
  var valuesLength = breakpoint + 1; // because breakpoints are indexed from 0
  // convert value and default value to arrays

  var newValueArr = toArray(newValue, valuesLength);
  var defaultValArr = toArray(defaultValue, valuesLength);
  var defaultVal = defaultValArr[0];
  var newVal = newValueArr[0] === undefined ? defaultVal : newValueArr[0]; // now we need to iterate only to breakpoint

  for (var i = 1; i <= breakpoint; i++) {
    defaultVal = defaultValArr[i] === undefined ? defaultVal : defaultValArr[i];
    newVal = newValueArr[i];
  } // new value is from user, default value is from source (e.g. theme)
  // new value always overrides default value
  // except if there is undefined value at the breakpoint's index


  return newVal !== undefined ? newVal : defaultVal;
}

function getScaleValue(value, position) {
  if (position === void 0) {
    position = 0;
  }

  var minValue = value.values[0];
  var maxValue = value.values[value.values.length - 1];
  var index = value.offset + position;

  if (index < 0) {
    return minValue;
  }

  if (index > value.values.length - 1) {
    return maxValue;
  }

  return value.values[index];
}

function isScaleValue(value) {
  return typeof value === 'object' && value !== null && typeof value.offset === 'number' && Array.isArray(value.values);
}

/* eslint-disable no-param-reassign */
var LRUCache = /*#__PURE__*/function () {
  function LRUCache(maxSize) {
    if (maxSize === void 0) {
      maxSize = 100;
    }

    this.hash = new Map();
    this.maxSize = maxSize;
  }

  var _proto = LRUCache.prototype;

  _proto.has = function has(key) {
    var hit = this.hash.get(key);

    if (hit) {
      this.moveToStart(hit);
      return true;
    }

    return false;
  };

  _proto.get = function get(key) {
    var hit = this.hash.get(key);

    if (hit) {
      this.moveToStart(hit);
      return hit.value;
    }

    return hit;
  };

  _proto.set = function set(key, value) {
    var record = {
      key: key,
      prev: undefined,
      value: value,
      next: this.head
    };
    this.hash.set(key, record);
    this.head = record;

    if (this.head.next) {
      this.head.next.prev = this.head;
    }

    if (!this.tail) {
      this.tail = this.head;
    }

    if (this.hash.size > this.maxSize && this.tail) {
      // remove last record
      this.hash["delete"](this.tail.key);
      var tail = this.tail;
      this.tail = tail.prev;
      tail.prev = undefined;
      tail.next = undefined;

      if (this.tail) {
        this.tail.next = undefined;
      }
    }

    return value;
  };

  _proto.moveToStart = function moveToStart(record) {
    if (this.head === record) {
      return;
    }

    if (this.tail === record) {
      record.prev.next = undefined;
      this.tail = record.prev;
    } else {
      record.prev.next = record.next;
      record.next.prev = record.prev;
    }

    this.head.prev = record;
    record.next = this.head;
    record.prev = undefined;
    this.head = record;
  };

  _createClass(LRUCache, [{
    key: "size",
    get: function get() {
      return this.hash.size;
    }
  }]);

  return LRUCache;
}();

/**
 * Omits props from an object based on settings
 */
function omitProps(props, settings) {
  var clone = _extends({}, props);

  var settingsLength = settings.length;

  for (var i = 0; i < settingsLength; i++) {
    var setting = settings[i];
    clone["data-" + setting.name] = clone[setting.prop] === undefined ? setting.defaultValue : clone[setting.prop];

    if (setting.stripProp) {
      delete clone[setting.prop];
    }
  }

  return clone;
}

/**
 * Parses property name and scale value index from scalePath
 */
function parseScaleValuePath(scalePath) {
  var _$split = ("" + scalePath).split('.'),
      path = _$split[0],
      offset = _$split[1];

  var index = Number(offset == null ? path : offset);
  return [path, Number.isNaN(index) ? 0 : index];
}

export { LRUCache, depthFirstObjectMerge, getResponsiveValue, getScaleValue, isScaleValue, omitProps, parseScaleValuePath };
//# sourceMappingURL=byteclaw.visage.utils.esm.js.map
